module.exports = __webpack_public_path__ + "44b5be8cf9ce126aa699cd9f3cef27b5.svg";